import { render } from "./ListPaging.vue?vue&type=template&id=141c45ad"
import script from "./ListPaging.vue?vue&type=script&lang=js"
export * from "./ListPaging.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__